import { render, staticRenderFns } from "./JIngJiaGongGao.vue?vue&type=template&id=cf1d45aa&scoped=true"
import script from "./JIngJiaGongGao.vue?vue&type=script&lang=js"
export * from "./JIngJiaGongGao.vue?vue&type=script&lang=js"
import style0 from "./JIngJiaGongGao.vue?vue&type=style&index=0&id=cf1d45aa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1d45aa",
  null
  
)

export default component.exports